"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[781],{

/***/ 4186:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var text = {
    "af": {
        "help": "Ek het die goedere nie ontvang nie",
        "quotaLimit": "USPS-opsporing nie beskikbaar nie. Limiet bereik.",
        "uspsLimitedTips": "USPS-opsporing is beperk weens beleidsveranderinge. Gradeer op vir meer opsporingsversoeke.",
        "learnMore": "Leer Meer",
        "upgradePlan": "Upgrade Now",
        "helpDesc": "Ons is baie jammer. 17TRACK is 'n derdeparty w\xeareldwye logistieke inligtingsaggregasieplatform wat jou in staat stel om die logistieke status van verskeie pakkette gerieflik te raadpleeg. Vir leveringsprobleme met pakkette, kontak die logistieke onderneming of die handelaar.",
        "helpTitle": "Geagte gebruiker",
        "website": "Offisi\xeble webwerf",
        "noWebsite": "Geen inligting oor die amptelike webwerf beskikbaar nie. Dit word aanbeveel om die verkoper te kontak.",
        "contact": "Logistiek kontakinfo",
        "userAgree": "Stem in tot die {0}",
        "userAgreeLink": "Diensbepalings",
        "uspsTrackingInstructions": "USPS-opsporingsinstruksies",
        "uspsInstructions1": "As gevolg van beleidsveranderinge deur USPS, gebruik USPS-tracking nou ’n toegewyde kwota. Betalende gebruikers kan USPS-spoorsnommers tot hul planlimiet per faktuursiklus byvoeg. Die kwota word outomaties herstel.",
        "uspsInstructions2": "As die beskikbare planne steeds nie aan jou USPS-trackingbehoeftes voldoen nie, kontak ons ondersteuningspan by "
    },
    "ar": {
        "help": "لم أتلقى البضاعة",
        "quotaLimit": "خدمة تتبع البريد الأمريكي غير متاحة. تم الوصول إلى الحد الأقصى.",
        "uspsLimitedTips": "تتبع USPS محدود بسبب تغييرات السياسة. قم بالترقية للحصول على المزيد من طلبات التتبع.",
        "learnMore": "يتعلم أكثر",
        "upgradePlan": "الترقية الآن",
        "helpDesc": "نأسف بغضب. 17TRACK منصة ثالثة لجمع معلومات اللوجستية العالمية، تتيح لك استعلام سهل عن حالة اللوجستية لأكثر من حزمة. ل문제 توصيل الحزم، يرجى الاتصال بالشركة اللوجستية أو التاجر.",
        "helpTitle": "ي المستخدم",
        "website": "الموقع الرسمي",
        "noWebsite": "لا توجد معلومات عن الموقع الرسمي متوفرة. يُنصح بمراسلة البائع.",
        "contact": "معلومات الاتصال باللوجستية",
        "userAgree": "الموافقة على {0}",
        "userAgreeLink": "شروط الخدمة",
        "uspsTrackingInstructions": "تعليمات تتبع USPS",
        "uspsInstructions1": "بسبب تغييرات سياسة USPS، يستخدم تتبع USPS الآن حصة مخصصة. يمكن للمستخدمين المدفوعين إضافة أرقام تتبع USPS وفقًا لحدود خطتهم لكل دورة فوترة. تتم إعادة تعيين الحصة تلقائيًا.",
        "uspsInstructions2": "إذا كانت الخطط المتاحة لا تزال لا تلبي احتياجات تتبع USPS الخاصة بك، فيرجى الاتصال بفريق الدعم لدينا على "
    },
    "az": {
        "help": "Mən malları almadım",
        "quotaLimit": "USPS izləmə m\xfcmk\xfcn deyil. Limitə \xe7atdınız",
        "uspsLimitedTips": "USPS izləmə siyasət dəyişikliklərinə g\xf6rə məhduddur. Daha \xe7ox izləmə sorğusu \xfc\xe7\xfcn y\xfcksəldin.",
        "learnMore": "Daha \xe7ox məlumat əldə edin",
        "upgradePlan": "İndi y\xfcksəlt",
        "helpDesc": "\xc7ox \xfczr istəyirik. 17TRACK qlobal \xfc\xe7\xfcnc\xfc tərəf lojistik məlumatlarını toplayan platformadır və sizə bir ne\xe7ə paketin lojistik vəziyyətini asanlıqla yoxlamağa imkan verir. Paketlərin \xe7atdırılma problemləri \xfc\xe7\xfcn lojistik şirkəti və ya satıcı ilə əlaqə qurun.",
        "helpTitle": "Hurmatlı istifadə\xe7i",
        "website": "Rəsmi veb sayt",
        "noWebsite": "Rəsmi veb sayt haqqında məlumat yoxdur. Satıcı ilə əlaqə qurmaq t\xf6vsiyə olunur.",
        "contact": "Lojistik kontakt məlumatı",
        "userAgree": "{0} razıyam",
        "userAgreeLink": "Xidmət şərtləri",
        "uspsTrackingInstructions": "USPS izləmə təlimatları",
        "uspsInstructions1": "USPS siyasətindəki dəyişikliklər səbəbindən USPS izləməsi artıq x\xfcsusi kvotadan istifadə edir. \xd6dənişli istifadə\xe7ilər hesablaşma d\xf6vr\xfc \xfczrə plan limitinə qədər USPS izləmə n\xf6mrələri əlavə edə bilərlər. Kvota avtomatik sıfırlanır.",
        "uspsInstructions2": "M\xf6vcud planlar hələ də USPS izləmə ehtiyaclarınızı qarşılamırsa, dəstək komandamızla  \xfcnvanından əlaqə saxlayın."
    },
    "bg": {
        "help": "Не получих стоките",
        "quotaLimit": "Проследяването на USPS не е налично. Достигнат е лимитът.",
        "uspsLimitedTips": "Проследяването на USPS е ограничено поради промени в политиката. Надстройте за повече заявки за проследяване.",
        "learnMore": "Научете повече",
        "upgradePlan": "Актуализирай сега",
        "helpDesc": "Много се съжаляваме. 17TRACK е трета страна глобална платформа за агрегация на логистични информация, която ви позволява лесно да проверявате логистическия статус на няколко пратки. При проблеми с доставката на пратките се свържете с логистическата фирма или търговеца.",
        "helpTitle": "Поважени потребител",
        "website": "Официален сайт",
        "noWebsite": "Няма налични информация за официалната уеб страница. Препоръчва се да се свържете с продавача.",
        "contact": "Контактна информация за логистиката",
        "userAgree": "Приемам {0}",
        "userAgreeLink": "Условия за ползване",
        "uspsTrackingInstructions": "Инструкции за проследяване на USPS",
        "uspsInstructions1": "Поради промени в политиката на USPS, проследяването на USPS вече използва специална квота. Платените потребители могат да добавят номера за проследяване на USPS до лимита на своя план за цикъл на фактуриране. Квотата се нулира автоматично.",
        "uspsInstructions2": "Ако наличните планове все още не отговарят на нуждите ви от проследяване на USPS, моля, свържете се с екипа ни за поддръжка на "
    },
    "cs": {
        "help": "Nedostal jsem zbož\xed",
        "quotaLimit": "Sledov\xe1n\xed USPS nen\xed k dispozici. Dosažen limit.",
        "uspsLimitedTips": "Sledov\xe1n\xed USPS je omezeno kvůli změn\xe1m z\xe1sad. Upgradujte pro v\xedce požadavků na sledov\xe1n\xed.",
        "learnMore": "Zjistěte v\xedce",
        "upgradePlan": "Upgradovat nyn\xed",
        "helpDesc": "Velmi se omlouv\xe1me. 17TRACK je třet\xed strana glob\xe1ln\xed platforma pro agregaci logistick\xfdch informac\xed, kter\xe1 v\xe1m umožňuje pohodlně zjistit logistick\xfd stav několika bal\xedků. Při probl\xe9mech s dodac\xedmi službami bal\xedků kontaktujte pros\xedm logistickou společnost nebo obchodn\xedka.",
        "helpTitle": "V\xe1žen\xed uživateli",
        "website": "Ofici\xe1ln\xed webov\xe1 str\xe1nka",
        "noWebsite": "Ž\xe1dn\xe9 informace o ofici\xe1ln\xed webov\xe9 str\xe1nce nejsou k dispozici. Doporučuje se kontaktovat prodejce.",
        "contact": "Logistick\xe1 kontaktn\xed info",
        "userAgree": "Souhlasit s {0}",
        "userAgreeLink": "Podm\xednky služby",
        "uspsTrackingInstructions": "Pokyny pro sledov\xe1n\xed USPS",
        "uspsInstructions1": "Kvůli změn\xe1m pravidel USPS nyn\xed sledov\xe1n\xed USPS využ\xedv\xe1 vyhrazenou kv\xf3tu. Plat\xedc\xed uživatel\xe9 mohou přid\xe1vat sledovac\xed č\xedsla USPS až do limitu sv\xe9ho pl\xe1nu za fakturačn\xed cyklus. Kv\xf3ta se automaticky resetuje.",
        "uspsInstructions2": "Pokud dostupn\xe9 pl\xe1ny st\xe1le nevyhovuj\xed vašim potřeb\xe1m sledov\xe1n\xed USPS, kontaktujte n\xe1š t\xfdm podpory na adrese "
    },
    "da": {
        "help": "Jeg har ikke modtaget varerne",
        "quotaLimit": "USPS-sporing ikke tilg\xe6ngelig. Gr\xe6nsen er n\xe5et.",
        "uspsLimitedTips": "USPS-sporing er begr\xe6nset p\xe5 grund af politik\xe6ndringer. Opgrader for flere sporingsforesp\xf8rgsler.",
        "learnMore": "L\xe6r mere",
        "upgradePlan": "Opgrader nu",
        "helpDesc": "Vi er utrolig undskyldne. 17TRACK er en tredjepartsplatform for global aggregation af logistisk information, der lader dig nemt kontrollere logistikstatusen for flere pakker. Ved leveringsproblemer med pakker skal du kontakte logistikselskabet eller forhandleren.",
        "helpTitle": "Dear user",
        "website": "Officiel website",
        "noWebsite": "Ingen information om den officielle hjemmeside tilg\xe6ngelig. Anbefales at kontakte s\xe6lgeren.",
        "contact": "Logistik kontaktinfo",
        "userAgree": "Accepter {0}",
        "userAgreeLink": "Vilk\xe5r for brug",
        "uspsTrackingInstructions": "USPS-sporingsinstruktioner",
        "uspsInstructions1": "P\xe5 grund af politik\xe6ndringer hos USPS bruger USPS-sporing nu en dedikeret kvote. Betalende brugere kan tilf\xf8je USPS-sporingsnumre op til deres plangr\xe6nse pr. faktureringscyklus. Kvoten nulstilles automatisk.",
        "uspsInstructions2": "Hvis de tilg\xe6ngelige planer stadig ikke opfylder dine USPS-sporingsbehov, bedes du kontakte vores supportteam p\xe5 "
    },
    "de": {
        "help": "Ich habe die Ware nicht erhalten",
        "quotaLimit": "USPS-Sendungsverfolgung nicht verf\xfcgbar. Limit erreicht.",
        "uspsLimitedTips": "USPS-Sendungsverfolgung ist aufgrund von Richtlinien\xe4nderungen eingeschr\xe4nkt. Upgraden Sie f\xfcr mehr Tracking-Anfragen.",
        "learnMore": "Mehr erfahren",
        "upgradePlan": "Jetzt upgraden",
        "helpDesc": "Wir entschuldigen uns zutiefst. 17TRACK ist eine drittanbieterische globale Logistikinformationsaggregationsplattform, mit der Sie den Logistikstatus mehrerer Pakete bequem abfragen k\xf6nnen. Bei Paketzustellproblemen wenden Sie sich bitte an das Logistikunternehmen oder den H\xe4ndler.",
        "helpTitle": "r geehrter Benutzer",
        "website": "Offizielle Website",
        "noWebsite": "Keine Informationen zur offiziellen Website verf\xfcgbar. Es wird empfohlen, sich an den Verk\xe4ufer zu wenden.",
        "contact": "Logistik-Kontaktinfo",
        "userAgree": "{0} zustimmen",
        "userAgreeLink": "Nutzungsbedingungen",
        "uspsTrackingInstructions": "USPS-Sendungsverfolgungsanleitung",
        "uspsInstructions1": "Aufgrund von Richtlinien\xe4nderungen der USPS verwendet die USPS-Sendungsverfolgung jetzt ein dediziertes Kontingent. Zahlende Nutzer k\xf6nnen pro Abrechnungszeitraum USPS-Sendungsnummern bis zu ihrem Planlimit hinzuf\xfcgen. Das Kontingent wird automatisch zur\xfcckgesetzt.",
        "uspsInstructions2": "Sollten die verf\xfcgbaren Tarife Ihren USPS-Tracking-Bedarf weiterhin nicht decken, kontaktieren Sie bitte unser Support-Team unter "
    },
    "el": {
        "help": "Δεν έλαβα τα προϊόντα",
        "quotaLimit": "Η παρακολούθηση USPS δεν είναι διαθέσιμη. Συμπληρώθηκε το όριο.",
        "uspsLimitedTips": "Η παρακολούθηση USPS είναι περιορισμένη λόγω αλλαγών πολιτικής. Αναβαθμίστε για περισσότερα αιτήματα παρακολούθησης.",
        "learnMore": "Μάθετε περισσότερα",
        "upgradePlan": "Αναβάθμιση τώρα",
        "helpDesc": "Σας ζητάμε συγνώμη πάρα πολύ. 17TRACK είναι μια πλατφόρμα τρίτου μέρους για συλλογή παγκόσμιων πληροφοριών λογιστικής, която σας επιτρέπει να ελέγξετε εύκολα την λογιστική κατάσταση πολλών πακέτων. Για προβλήματα παράδοσης πακέτων, επικοινωνήστε με την εταιρεία λογιστικής ή τον εμπόρο.",
        "helpTitle": "Αγαπητέ χρήστη",
        "website": "Επίσημοι ιστότοποι",
        "noWebsite": "Δεν υπάρχουν διαθέσιμες πληροφορίες για τον επίσημο ιστότοπο. Συνιστάται να επικοινωνήσετε με τον πωλητή.",
        "contact": "Λογιστική πληροφορίες επικοινωνίας",
        "userAgree": "Αποδοχή των {0}",
        "userAgreeLink": "Όροι χρήσης",
        "uspsTrackingInstructions": "Οδηγίες παρακολούθησης USPS",
        "uspsInstructions1": "Λόγω αλλαγών πολιτικής της USPS, η παρακολούθηση USPS χρησιμοποιεί πλέον ειδική ποσόστωση. Οι χρήστες που πληρώνουν μπορούν να προσθέτουν αριθμούς παρακολούθησης USPS εντός του ορίου του προγράμματός τους ανά κύκλο χρέωσης. Η ποσόστωση επαναφέρεται αυτόματα.",
        "uspsInstructions2": "Εάν τα διαθέσιμα προγράμματα εξακολουθούν να μην καλύπτουν τις ανάγκες σας για παρακολούθηση USPS, επικοινωνήστε με την ομάδα υποστήριξής μας στο "
    },
    "en": {
        "help": "I have not received the goods",
        "quotaLimit": "USPS tracking unavailable. Limit reached",
        "uspsLimitedTips": "USPS tracking is limited due to policy changes. Upgrade for more tracking requests.",
        "learnMore": "Learn More",
        "upgradePlan": "Upgrade Now",
        "helpDesc": "We are extremely sorry. 17TRACK is a third-party global logistics information aggregation platform that enables you to conveniently check the logistics status of multiple parcels. For parcel delivery issues, please contact the logistics company or the merchant.",
        "helpTitle": "Dear user",
        "website": "Official website",
        "noWebsite": "No official website information available. It is recommended to contact the seller.",
        "contact": "Logistics contact info",
        "userAgree": "Agree to the {0}",
        "userAgreeLink": "Terms of Service",
        "uspsTrackingInstructions": "USPS Tracking Instructions",
        "uspsInstructions1": "Due to USPS policy changes, USPS tracking now uses a dedicated quota. Paid users can add USPS tracking numbers up to their plan limit per billing cycle (auto-reset).",
        "uspsInstructions2": "If the available plans still do not meet your USPS tracking needs, please contact our support team at "
    },
    "es": {
        "help": "No he recibido la mercanc\xeda",
        "quotaLimit": "Seguimiento de USPS no disponible. L\xedmite alcanzado.",
        "uspsLimitedTips": "El seguimiento de USPS est\xe1 limitado debido a cambios de pol\xedtica. Actualiza para obtener m\xe1s solicitudes de seguimiento.",
        "learnMore": "M\xe1s informaci\xf3n",
        "upgradePlan": "Actualizar ahora",
        "helpDesc": "Lamentamos profundamente. 17TRACK es una plataforma de agregaci\xf3n de informaci\xf3n log\xedstica global de terceros que le permite consultar convenientemente el estado log\xedstico de m\xfaltiples paquetes. Para problemas de entrega de paquetes, cont\xe1ctese con la empresa log\xedstica o el comerciante.",
        "helpTitle": "Dear user",
        "website": "Sitio web oficial",
        "noWebsite": "No hay informaci\xf3n de sitio web oficial disponible. Se recomienda contactar al vendedor.",
        "contact": "Info de contacto de log\xedstica",
        "userAgree": "Aceptar los {0}",
        "userAgreeLink": "T\xe9rminos de servicio",
        "uspsTrackingInstructions": "Instrucciones de seguimiento de USPS",
        "uspsInstructions1": "Debido a cambios en las pol\xedticas de USPS, el seguimiento de USPS ahora utiliza una cuota dedicada. Los usuarios de pago pueden agregar n\xfameros de seguimiento de USPS hasta el l\xedmite de su plan por ciclo de facturaci\xf3n. La cuota se restablece autom\xe1ticamente.",
        "uspsInstructions2": "Si los planes disponibles a\xfan no satisfacen sus necesidades de seguimiento de USPS, comun\xedquese con nuestro equipo de soporte en "
    },
    "fi": {
        "help": "En ole saanut tavaroita",
        "quotaLimit": "USPS-seuranta ei ole k\xe4ytett\xe4viss\xe4. Raja saavutettu.",
        "uspsLimitedTips": "USPS-seuranta on rajoitettu k\xe4yt\xe4nt\xf6muutosten vuoksi. P\xe4ivit\xe4 saadaksesi lis\xe4\xe4 seurantapyynt\xf6j\xe4.",
        "learnMore": "Lue lis\xe4\xe4",
        "upgradePlan": "P\xe4ivit\xe4 nyt",
        "helpDesc": "Olemme eritt\xe4in pahoillamme. 17TRACK on maailmanlaajuinen kolmannen osapuolen logistisen tietojen yhdist\xe4misplattformi, joka mahdollistaa useiden pakettien logistisen tilanteen helpon tarkistamisen. Pakettitoimitusongelmissa ota yhteytt\xe4 logistiseen yritykseen tai kauppiaan.",
        "helpTitle": "Arvoisa k\xe4ytt\xe4j\xe4",
        "website": "Virallinen verkkosivu",
        "noWebsite": "Virallisen verkkosivun tietoja ei ole saatavilla. Suositellaan ottamaan yhteytt\xe4 myyj\xe4\xe4n.",
        "contact": "Logistikan kontaktiinfo",
        "userAgree": "Hyv\xe4ksy {0}",
        "userAgreeLink": "K\xe4ytt\xf6ehdot",
        "uspsTrackingInstructions": "USPS-seurantaohjeet",
        "uspsInstructions1": "USPS:n k\xe4yt\xe4nt\xf6muutosten vuoksi USPS-seuranta k\xe4ytt\xe4\xe4 nyt erillist\xe4 kiinti\xf6t\xe4. Maksavat k\xe4ytt\xe4j\xe4t voivat lis\xe4t\xe4 USPS-seurantanumeroita laskutusjakson aikana pakettinsa rajoihin asti. Kiinti\xf6 nollautuu automaattisesti.",
        "uspsInstructions2": "Jos saatavilla olevat paketit eiv\xe4t viel\xe4k\xe4\xe4n t\xe4yt\xe4 USPS-seurantatarpeitasi, ota yhteytt\xe4 tukeemme osoitteeseen ."
    },
    "fil": {
        "help": "Hindi ko natanggap ang mga paninda",
        "quotaLimit": "Hindi magagamit ang pagsubaybay sa USPS. Naabot na ang limitasyon.",
        "uspsLimitedTips": "Limitado ang USPS tracking dahil sa pagbabago ng patakaran. Mag-upgrade para sa mas maraming tracking requests.",
        "learnMore": "Matuto Nang Higit Pa",
        "upgradePlan": "Mag-upgrade ngayon",
        "helpDesc": "Lubos kaming humihingi ng paumanhin. 17TRACK ay isang third-party na pandaigdigang plataporma ng pagsasama-sama ng impormasyon sa logistika, na nagbibigay-daan sa iyo na madaling suriin ang estado ng logistika ng maraming pakete. Para sa mga problema sa paghahatid ng pakete, makipag-ugnayan sa kumpanyang logistika o sa mangangalakal.",
        "helpTitle": "Dear user",
        "website": "Opisyal na website",
        "noWebsite": "Walang available na impormasyon sa opisyal na website. Inirerekomenda na makipag-ugnayan sa nagbebenta.",
        "contact": "Info ng kontakto ng logistika",
        "userAgree": "Sumang-ayon sa {0}",
        "userAgreeLink": "Mga Tuntunin ng Serbisyo",
        "uspsTrackingInstructions": "Mga tagubilin sa pagsubaybay ng USPS",
        "uspsInstructions1": "Dahil sa mga pagbabago sa patakaran ng USPS, ang pagsubaybay sa USPS ay gumagamit na ngayon ng nakalaang quota. Maaaring magdagdag ang mga bayad na user ng mga numero ng pagsubaybay ng USPS hanggang sa limitasyon ng kanilang plano bawat cycle ng pagsingil. Awtomatikong nire-reset ang quota.",
        "uspsInstructions2": "Kung hindi pa rin natutugunan ng mga available na plano ang iyong mga pangangailangan sa pagsubaybay sa USPS, mangyaring makipag-ugnayan sa aming support team sa "
    },
    "fr": {
        "help": "Je n'ai pas re\xe7u la marchandise",
        "quotaLimit": "Suivi USPS indisponible. Limite atteinte.",
        "uspsLimitedTips": "Le suivi USPS est limit\xe9 en raison de changements de politique. Passez \xe0 un niveau sup\xe9rieur pour plus de demandes de suivi.",
        "learnMore": "Apprendre encore plus",
        "upgradePlan": "Mettre \xe0 niveau",
        "helpDesc": "Nous sommes extr\xeamement d\xe9sol\xe9s. 17TRACK est une plateforme tierce d'agr\xe9gation d'informations logistiques globales, qui vous permet de consulter facilement l'\xe9tat logistique de plusieurs colis. Pour les probl\xe8mes de livraison des colis, veuillez contacter la soci\xe9t\xe9 logistique ou le commer\xe7ant.",
        "helpTitle": "Cher utilisateur",
        "website": "Site officiel",
        "noWebsite": "Aucune information sur le site officiel disponible. Il est recommand\xe9 de contacter le vendeur.",
        "contact": "Info de contact de logistique",
        "userAgree": "Accepter les {0}",
        "userAgreeLink": "Conditions d'utilisation",
        "uspsTrackingInstructions": "Instructions de suivi USPS",
        "uspsInstructions1": "En raison des changements de politique d’USPS, le suivi USPS utilise d\xe9sormais un quota d\xe9di\xe9. Les utilisateurs payants peuvent ajouter des num\xe9ros de suivi USPS dans la limite de leur forfait par cycle de facturation. Le quota est automatiquement r\xe9initialis\xe9.",
        "uspsInstructions2": "Si les forfaits disponibles ne r\xe9pondent toujours pas \xe0 vos besoins de suivi USPS, veuillez contacter notre \xe9quipe d’assistance \xe0 "
    },
    "he": {
        "help": "לא קיבלתי את המוצרים",
        "quotaLimit": "מעקב USPS אינו זמין. הגעת למגבלה.",
        "uspsLimitedTips": "מעקב USPS מוגבל עקב שינויי מדיניות. שדרג לקבלת יותר בקשות מעקב.",
        "learnMore": "למידע נוסף",
        "upgradePlan": "שדרג עכשיו",
        "helpDesc": "אנחנו מתנצלים מאוד. 17TRACK היא פלטפורמה של צד שלישי לקובץ מידע לוגיסטי גלובלי, המאפשרת לך לבדוק בקלות את מצב הלוגיסטיקה של מספר חבילות. לבעיות אספקה של חבילות, אנא צור קשר עם חברת הלוגיסטיקה או הסוחר.",
        "helpTitle": "יקירי משתמש",
        "website": "אתר רשמי",
        "noWebsite": "אין מידע על האתר הרשמי זמין. מומלץ לפנות לממוכר.",
        "contact": "מידע יצירת קשר ללוגיסטיקה",
        "userAgree": "מסכים ל-{0}",
        "userAgreeLink": "תנאי השירות",
        "uspsTrackingInstructions": "הוראות מעקב USPS",
        "uspsInstructions1": "עקב שינויים במדיניות USPS, מעקב USPS משתמש כעת במכסה ייעודית. משתמשים בתשלום יכולים להוסיף מספרי מעקב של USPS עד למגבלת התוכנית שלהם לכל מחזור חיוב. המכסה מתאפסת אוטומטית.",
        "uspsInstructions2": "אם התוכניות הזמינות עדיין אינן עונות על צרכי מעקב USPS שלך, אנא צור קשר עם צוות התמיכה שלנו בכתובת "
    },
    "hi": {
        "help": "मुझे माल नहीं मिला",
        "quotaLimit": "यूएसपीएस ट्रैकिंग अनुपलब्ध है। सीमा पूरी हो गई है।",
        "uspsLimitedTips": "नीति परिवर्तन के कारण USPS ट्रैकिंग सीमित है। अधिक ट्रैकिंग अनुरोधों के लिए अपग्रेड करें।",
        "learnMore": "और अधिक जानें",
        "upgradePlan": "अभी अपग्रेड करें",
        "helpDesc": "हम बहुत खेदित हैं। 17TRACK एक वैश्विक लॉजिस्टिक्स सूचना तृतीय पक्ष एकत्रीकरण प्लेटफॉर्म है, जो आपको कई पार्सल के लॉजिस्टिक्स स्टेटस को आसानी से जांचने की अनुमति देता है। पार्सल की डिलीवरी की समस्याओं के लिए, कृपया लॉजिस्टिक्स कंपनी या व्यापारी से संपर्क करें।",
        "helpTitle": "प्रिय उपयोगकर्ता",
        "website": "आधिकारिक वेबसाइट",
        "noWebsite": "कोई आधिकारिक वेबसाइट की जानकारी उपलब्ध नहीं है। विक्रेता से संपर्क करने की सलाह दी जाती है।",
        "contact": "लॉजिस्टिक कंपनी संपर्क जानकारी",
        "userAgree": "{0} से सहमत",
        "userAgreeLink": "सेवा की शर्तें",
        "uspsTrackingInstructions": "USPS ट्रैकिंग निर्देश",
        "uspsInstructions1": "USPS नीति परिवर्तनों के कारण, USPS ट्रैकिंग अब एक समर्पित कोटा का उपयोग करती है। सशुल्क उपयोगकर्ता प्रति बिलिंग चक्र अपनी योजना सीमा तक USPS ट्रैकिंग नंबर जोड़ सकते हैं। कोटा स्वचालित रूप से रीसेट हो जाता है।",
        "uspsInstructions2": "यदि उपलब्ध योजनाएँ अभी भी आपकी USPS ट्रैकिंग आवश्यकताओं को पूरा नहीं करती हैं, तो कृपया हमारी सहायता टीम से  पर संपर्क करें।"
    },
    "hu": {
        "help": "Nem kaptam meg a term\xe9ket",
        "quotaLimit": "USPS k\xf6vet\xe9s nem el\xe9rhető. El\xe9rte a limitet.",
        "uspsLimitedTips": "A USPS k\xf6vet\xe9s korl\xe1tozott a szab\xe1lyzatv\xe1ltoz\xe1sok miatt. Friss\xedtsen t\xf6bb k\xf6vet\xe9si k\xe9relem\xe9rt.",
        "learnMore": "Tudj meg t\xf6bbet",
        "upgradePlan": "Friss\xedt\xe9s most",
        "helpDesc": "Nagyon sajn\xe1ljuk. 17TRACK egy harmadik f\xe9l \xe1ltal műk\xf6dtetett glob\xe1lis logisztikai inform\xe1ci\xf3-aggreg\xe1ci\xf3s platform, amely lehetőv\xe9 teszi, hogy k\xf6nnyen ellenőrizd t\xf6bb csomag logisztikai \xe1llapot\xe1t. Csomagsz\xe1ll\xedt\xe1si probl\xe9m\xe1k eset\xe9n l\xe9pj kapcsolatba a logisztikai c\xe9ggel vagy a kereskedővel.",
        "helpTitle": "Kedves felhaszn\xe1l\xf3",
        "website": "Hivatalos weboldal",
        "noWebsite": "Nincsenek el\xe9rhető inform\xe1ci\xf3k az hivatalos weboldalr\xf3l. Aj\xe1nlott a elad\xf3t felvenni.",
        "contact": "Logisztikai kapcsolati info",
        "userAgree": "Elfogadom a(z) {0}",
        "userAgreeLink": "Szolg\xe1ltat\xe1si felt\xe9telek",
        "uspsTrackingInstructions": "USPS k\xf6vet\xe9si \xfatmutat\xf3",
        "uspsInstructions1": "Az USPS ir\xe1nyelvv\xe1ltoz\xe1sai miatt az USPS-k\xf6vet\xe9s mostant\xf3l dedik\xe1lt kv\xf3t\xe1t haszn\xe1l. A fizetős felhaszn\xe1l\xf3k sz\xe1ml\xe1z\xe1si ciklusonk\xe9nt a csomagjuk keret\xe9ig adhatnak hozz\xe1 USPS-k\xf6vet\xe9si sz\xe1mokat. A kv\xf3ta automatikusan vissza\xe1ll.",
        "uspsInstructions2": "Ha a rendelkez\xe9sre \xe1ll\xf3 csomagok tov\xe1bbra sem felelnek meg az USPS-k\xf6vet\xe9si ig\xe9nyeinek, vegye fel a kapcsolatot t\xe1mogat\xe1si csapatunkkal a  c\xedmen."
    },
    "id": {
        "help": "Saya belum menerima barang",
        "quotaLimit": "Pelacakan USPS tidak tersedia. Batas telah tercapai.",
        "uspsLimitedTips": "Pelacakan USPS dibatasi karena perubahan kebijakan. Upgrade untuk lebih banyak permintaan pelacakan.",
        "learnMore": "Pelajari Selengkapnya",
        "upgradePlan": "Upgrade sekarang",
        "helpDesc": "Kami sangat menyesal. 17TRACK adalah platform agregasi informasi logistik global pihak ketiga yang memungkinkan Anda dengan mudah memeriksa status logistik beberapa paket. Untuk masalah pengiriman paket, silakan hubungi perusahaan logistik atau pedagang.",
        "helpTitle": "Yang terhormat pengguna",
        "website": "Situs resmi",
        "noWebsite": "Tidak ada informasi situs resmi yang tersedia. Disarankan untuk menghubungi penjual.",
        "contact": "Info kontak logistik",
        "userAgree": "Setuju dengan {0}",
        "userAgreeLink": "Ketentuan Layanan",
        "uspsTrackingInstructions": "Instruksi pelacakan USPS",
        "uspsInstructions1": "Karena perubahan kebijakan USPS, pelacakan USPS sekarang menggunakan kuota khusus. Pengguna berbayar dapat menambahkan nomor pelacakan USPS hingga batas paket mereka per siklus penagihan. Kuota diatur ulang secara otomatis.",
        "uspsInstructions2": "Jika paket yang tersedia masih belum memenuhi kebutuhan pelacakan USPS Anda, silakan hubungi tim dukungan kami di "
    },
    "is": {
        "help": "\xc9g hef ekki fengi\xf0 v\xf6rurnar",
        "quotaLimit": "USPS rakning ekki \xed bo\xf0i. Takm\xf6rkum n\xe1\xf0.",
        "uspsLimitedTips": "USPS-rakning er takm\xf6rku\xf0 vegna stefnubreytinga. Uppf\xe6r\xf0u til a\xf0 f\xe1 fleiri rakningarbei\xf0nir.",
        "learnMore": "Frekari uppl\xfdsingar",
        "upgradePlan": "Uppf\xe6ra n\xfana",
        "helpDesc": "Vi\xf0 erum mj\xf6g lei\xf0inleg. 17TRACK er \xferi\xf0ja a\xf0ila al\xfej\xf3\xf0legur stj\xf3rns\xfdsla fyrir flutningsuppl\xfdsingar, sem gerir \xfe\xe9r kleift a\xf0 athuga au\xf0veldlega flutningssta\xf0an hj\xe1 nokkrum pakkana. Vi\xf0 flutningsproblemem me\xf0 pakkum, haf\xf0u samband vi\xf0 flutningsfyrirt\xe6ki\xf0 e\xf0a s\xf6lua\xf0ilinn.",
        "helpTitle": "K\xe6re notandi",
        "website": "Opinber vefs\xed\xf0a",
        "noWebsite": "Engar uppl\xfdsingar um opinbera vefs\xed\xf0una tilt\xe6kar. M\xe6lt er me\xf0 a\xf0 hafa samband vi\xf0 seljanda.",
        "contact": "Flutningskontaktinfo",
        "userAgree": "Sam\xfeykkja {0}",
        "userAgreeLink": "Skilm\xe1lar \xfej\xf3nustu",
        "uspsTrackingInstructions": "USPS rakningarlei\xf0beiningar",
        "uspsInstructions1": "Vegna breytinga \xe1 stefnu USPS, notar USPS-rakning n\xfa s\xe9rstakt kv\xf3ta. Grei\xf0andi notendur geta b\xe6tt vi\xf0 USPS-rakningarn\xfamerum allt a\xf0 pl\xe1neturm\xf6rkum \xe1 hverjum reikningsferli. Kv\xf3tinn endurstillist sj\xe1lfkrafa.",
        "uspsInstructions2": "Ef tilt\xe6kar \xe1\xe6tlanir uppfylla enn ekki USPS-rakningarfarir \xfe\xednar, vinsamlegast haf\xf0u samband vi\xf0 stu\xf0ningsteymi\xf0 okkar \xe1 "
    },
    "it": {
        "help": "Non ho ricevuto la merce",
        "quotaLimit": "Tracciamento USPS non disponibile. Limite raggiunto.",
        "uspsLimitedTips": "Il tracciamento USPS \xe8 limitato a causa di modifiche alle politiche. Aggiorna per ottenere pi\xf9 richieste di tracciamento.",
        "learnMore": "Saperne di pi\xf9",
        "upgradePlan": "Aggiorna ora",
        "helpDesc": "Ci dispiace moltissimo. 17TRACK \xe8 una piattaforma terza per l'aggregazione di informazioni logistiche globali, che consente di consultare comodamente lo stato logistico di pi\xf9 pacchetti. Per problemi di consegna dei pacchetti, contattare l'azienda logistica o il commerciante.",
        "helpTitle": "Dear user",
        "website": "Sito ufficiale",
        "noWebsite": "Nessuna informazione sul sito ufficiale disponibile. Si consiglia di contattare il venditore.",
        "contact": "Info di contatto della logistica",
        "userAgree": "Accetta i {0}",
        "userAgreeLink": "Termini di servizio",
        "uspsTrackingInstructions": "Istruzioni per il tracciamento USPS",
        "uspsInstructions1": "A causa delle modifiche alle policy di USPS, il tracking USPS utilizza ora una quota dedicata. Gli utenti paganti possono aggiungere numeri di tracking USPS entro il limite del proprio piano per ciclo di fatturazione. La quota viene azzerata automaticamente.",
        "uspsInstructions2": "Se i piani disponibili non soddisfano ancora le tue esigenze di tracciamento USPS, contatta il nostro team di supporto all’indirizzo "
    },
    "ja": {
        "help": "商品を受け取っていません",
        "quotaLimit": "USPSの追跡サービスは利用できません。上限に達しました。",
        "uspsLimitedTips": "ポリシー変更により、USPS追跡は制限されています。アップグレードして追跡リクエストを増やしましょう。",
        "learnMore": "もっと詳しく知る",
        "upgradePlan": "今すぐアップグレード",
        "helpDesc": "大変申し訳ございません。17TRACK はグローバルな物流情報サードパーティーアグリゲーションプラットフォームで、複数の荷物の物流状況を簡便に確認できます。荷物の配送に関する問題がある場合は、物流会社または事業者にお問い合わせください。",
        "helpTitle": "尊敬するユーザー様",
        "website": "公式サイト",
        "noWebsite": "公式サイトの情報は現在入手できません。売り手に連絡することを推奨します。",
        "contact": "物流会社連絡先",
        "userAgree": "{0}に同意する",
        "userAgreeLink": "利用規約",
        "uspsTrackingInstructions": "USPS追跡手順",
        "uspsInstructions1": "USPS のポリシー変更により、USPS トラッキングは専用枠制となりました。有料ユーザーは、請求サイクルごとにプランの上限まで USPS トラッキング番号を追加できます。枠は自動的にリセットされます。",
        "uspsInstructions2": "ご利用のプランで USPS トラッキングのニーズを満たせない場合は、サポートチーム（）までお問い合わせください。"
    },
    "kk": {
        "help": "Мен тауарды алмадым",
        "quotaLimit": "USPS бақылауы мүмкін емес. Шектеуге жеттіңіз",
        "uspsLimitedTips": "USPS бақылауы саясат өзгерістеріне байланысты шектелген. Көбірек бақылау сұрауы үшін жаңартыңыз.",
        "learnMore": "Көбірек білу үшін",
        "upgradePlan": "Қазір жаңарту",
        "helpDesc": "Біз өте келіңіздерді кешірмеймініз. 17TRACK дүниежүзілік логистикалық ақпараттарды топтау \xfc\xe7\xfcn үшінші тарапті платформа болып табылады, ол сізге бірнеше посылаларының логистикалық жағдайын оңай тексеруге мүмкіндік береді. Посылалarın доставка проблемалары үшін логистикалық компанияға немесе саудашына хабарласудыңızды сұраймыз.",
        "helpTitle": "Құрметті пайдаланушы",
        "website": "Официалды веб-сайт",
        "noWebsite": "Официалды веб-сайт туралы ақпарат жоқ. Сатушымен байланысуға кеңес берілді.",
        "contact": "Логистика контактті ақпараты",
        "userAgree": "{0} келісемін",
        "userAgreeLink": "Қызмет көрсету шарттары",
        "uspsTrackingInstructions": "USPS бақылау нұсқаулығы",
        "uspsInstructions1": "USPS саясатындағы өзгерістерге байланысты USPS бақылау қызметі енді арнайы квотаны пайдаланады. Төлеуші пайдаланушылар әрбір есеп айырысу кезеңінде өз жоспарының шегіне дейін USPS бақылау нөмірлерін қоса алады. Квота автоматты түрде қалпына келеді.",
        "uspsInstructions2": "Қолжетімді жоспарлар әлі де USPS бақылау қажеттіліктеріңізді қанағаттандырмаса,  мекенжайы бойынша қолдау тобымызға хабарласыңыз."
    },
    "ko": {
        "help": "상품을 받지 못했어요",
        "quotaLimit": "USPS 추적 서비스를 이용할 수 없습니다. 이용 한도에 도달했습니다.",
        "uspsLimitedTips": "정책 변경으로 인해 USPS 추적이 제한됩니다. 더 많은 추적 요청을 위해 업그레이드하세요.",
        "learnMore": "더 알아보기",
        "upgradePlan": "지금 업그레이드",
        "helpDesc": "대단히 죄송합니다. 17TRACK는 글로벌 물류 정보 제3자 집계 플랫폼으로, 여러 패키지의 물류 상태를 편리하게 조회할 수 있도록 해줍니다. 패키지 배송 문제는 물류 회사 또는 상점에 문의하세요.",
        "helpTitle": "존경하는 사용자님",
        "website": "공식 웹사이트",
        "noWebsite": "공식 웹사이트 정보가 없습니다. 판매자에게 문의하는 것이 좋습니다.",
        "contact": "물류사 연락처",
        "userAgree": "{0}에 동의",
        "userAgreeLink": "서비스 약관",
        "uspsTrackingInstructions": "USPS 추적 안내",
        "uspsInstructions1": "USPS 정책 변경으로 인해 USPS 추적은 전용 할당량을 사용합니다. 유료 사용자는 청구 주기별로 요금제 한도까지 USPS 추적 번호를 추가할 수 있으며, 할당량은 자동으로 초기화됩니다.",
        "uspsInstructions2": "사용 가능한 요금제로도 USPS 추적 요구 사항을 충족할 수 없는 경우 지원팀()으로 문의하시기 바랍니다."
    },
    "lt": {
        "help": "Aš nenusipirkau prekių",
        "quotaLimit": "USPS sekimas negalimas. Pasiekta riba.",
        "uspsLimitedTips": "USPS sekimas ribojamas dėl politikos pakeitimų. Atnaujinkite, kad gautumėte daugiau sekimo užklausų.",
        "learnMore": "Sužinokite daugiau",
        "upgradePlan": "Atnaujinti dabar",
        "helpDesc": "Mes labai atsiprašome. 17TRACK yra trečiosios šalies globalinė logistikos informacijos agregavimo platforma, leidžianti lengvai patikrinti kelių siuntų logistikos būseną. Siuntimo problemoms susisiekite su logistikos įmone arba prekybininku.",
        "helpTitle": "Gerbiamas vartotojas",
        "website": "Oficialus tinklalapis",
        "noWebsite": "Oficialaus tinklalapio informacijų nėra. Rekomenduojama susisiekti su pardavėju.",
        "contact": "Logistikos kontaktinė info",
        "userAgree": "Sutinku su {0}",
        "userAgreeLink": "Paslaugos teikimo sąlygos",
        "uspsTrackingInstructions": "USPS sekimo instrukcijos",
        "uspsInstructions1": "Dėl USPS politikos pakeitimų, USPS sekimas dabar naudoja skirtą kvotą. Mokantys vartotojai gali pridėti USPS sekimo numerius iki savo plano limito per atsiskaitymo ciklą. Kvota automatiškai atstatoma.",
        "uspsInstructions2": "Jei turimi planai vis dar neatitinka jūsų USPS stebėjimo poreikių, susisiekite su mūsų palaikymo komanda el. paštu "
    },
    "mk": {
        "help": "Не добив производот",
        "quotaLimit": "Следењето на USPS е недостапно. Ограничувањето е достигнато.",
        "uspsLimitedTips": "Следењето на USPS е ограничено поради промени во политиката. Надградете за повеќе барања за следење.",
        "learnMore": "Дознајте повеќе",
        "upgradePlan": "Надгради сега",
        "helpDesc": "Многу се извинуваме. 17TRACK е трета страна глобална платформа за агрегација на логистички информации, која ви овозможува лесно да проверувате логистичкиот статус на неколку пакети. За проблеми со испорачката на пакетите, контактирајте логистичката компанија или трговецот.",
        "helpTitle": "Доштен корисник",
        "website": "Официјален сајт",
        "noWebsite": "Нема информации за официјалната веб страница. Препорачливо е да се контактирате со продавачот.",
        "contact": "Контактна информација за логистиката",
        "userAgree": "Се согласувам со {0}",
        "userAgreeLink": "Услови за користење",
        "uspsTrackingInstructions": "Упатства за следење USPS",
        "uspsInstructions1": "Поради промени во политиките на USPS, следењето на USPS сега користи посветена квота. Корисниците што плаќаат можат да додаваат броеви за следење на USPS до границата на нивниот план по циклус на наплата. Квотата автоматски се ресетира.",
        "uspsInstructions2": "Доколку достапните планови с\xe8 уште не ги задоволуваат вашите потреби за следење USPS, ве молиме контактирајте го нашиот тим за поддршка на "
    },
    "ms": {
        "help": "Saya belum menerima barang",
        "quotaLimit": "Penjejakan USPS tidak tersedia. Had dicapai",
        "uspsLimitedTips": "Penjejakan USPS terhad kerana perubahan polisi. Naik taraf untuk lebih banyak permintaan penjejakan.",
        "learnMore": "Ketahui Lebih Lanjut",
        "upgradePlan": "Naik taraf sekarang",
        "helpDesc": "Kami sangat menyesal. 17TRACK ialah platform agregasi maklumat logistik global pihak ketiga yang membolehkan anda menyemak status logistik beberapa pakej dengan mudah. Untuk masalah penghantaran pakej, sila hubungi syarikat logistik atau pengusaha.",
        "helpTitle": "Yang dihormati pengguna",
        "website": "Laman web rasmi",
        "noWebsite": "Tiada maklumat laman web rasmi tersedia. Dicadangkan untuk menghubungi penjual.",
        "contact": "Info kontak logistik",
        "userAgree": "Setuju dengan {0}",
        "userAgreeLink": "Terma Perkhidmatan",
        "uspsTrackingInstructions": "Arahan penjejakan USPS",
        "uspsInstructions1": "Disebabkan oleh perubahan dasar USPS, penjejakan USPS kini menggunakan kuota khusus. Pengguna berbayar boleh menambah nombor penjejakan USPS sehingga had pelan mereka setiap kitaran bil. Kuota ditetapkan semula secara automatik.",
        "uspsInstructions2": "Jika pelan yang tersedia masih tidak memenuhi keperluan penjejakan USPS anda, sila hubungi pasukan sokongan kami di "
    },
    "nl": {
        "help": "Ik heb de goederen niet ontvangen",
        "quotaLimit": "USPS-tracking niet beschikbaar. Limiet bereikt.",
        "uspsLimitedTips": "USPS-tracking is beperkt door beleidswijzigingen. Upgrade voor meer trackingverzoeken.",
        "learnMore": "Meer informatie",
        "upgradePlan": "Nu upgraden",
        "helpDesc": "Wij zijn u zeer erbarmelijk. 17TRACK is een derde-partijplatform voor wereldwijd aggregatie van logistieke informatie, waardoor u de logistieke status van meerdere pakketten gemakkelijk kunt opvragen. Bij problemen met de levering van pakketten neem dan contact op met het logistieke bedrijf of de handelaar.",
        "helpTitle": "Geachte gebruiker",
        "website": "Offici\xeble website",
        "noWebsite": "Geen informatie over de offici\xeble website beschikbaar. Raadpleeg de verkoper.",
        "contact": "Logistiek contactinfo",
        "userAgree": "Akkoord gaan met de {0}",
        "userAgreeLink": "Gebruiksvoorwaarden",
        "uspsTrackingInstructions": "USPS-trackinginstructies",
        "uspsInstructions1": "Vanwege beleidswijzigingen van USPS gebruikt USPS-tracking nu een speciaal quotum. Betalende gebruikers kunnen per factureringscyclus USPS-trackingnummers toevoegen tot hun plangrens. Het quotum wordt automatisch gereset.",
        "uspsInstructions2": "Als de beschikbare abonnementen nog steeds niet voldoen aan uw USPS-trackingbehoeften, neem dan contact op met ons ondersteuningsteam via "
    },
    "no": {
        "help": "Jeg har ikke f\xe5tt varene",
        "quotaLimit": "USPS-sporing utilgjengelig. Grensen er n\xe5dd.",
        "uspsLimitedTips": "USPS-sporing er begrenset p\xe5 grunn av policyendringer. Oppgrader for flere sporingsforesp\xf8rsler.",
        "learnMore": "L\xe6r mer",
        "upgradePlan": "Oppgrader n\xe5",
        "helpDesc": "Vi er sv\xe6rt lei. 17TRACK er en tredjepartsplatform for global aggregering av logistisk informasjon som lar deg enkelt sjekke logistikstatusen til flere pakker. Ved leveringsproblemer med pakker, kontakt logistikselskapet eller forhandleren.",
        "helpTitle": "Kj\xe6re bruker",
        "website": "Offisiell nettside",
        "noWebsite": "Ingen informasjon om den offisielle nettsiden tilgjengelig. Anbefales \xe5 kontakte selgeren.",
        "contact": "Logistikk kontaktinfo",
        "userAgree": "Godta {0}",
        "userAgreeLink": "Bruksvilk\xe5r",
        "uspsTrackingInstructions": "USPS-sporingsinstruksjoner",
        "uspsInstructions1": "P\xe5 grunn av policyendringer hos USPS bruker USPS-sporing n\xe5 en dedikert kvote. Betalende brukere kan legge til USPS-sporingsnumre opp til plankravet per faktureringssyklus. Kvoten tilbakestilles automatisk.",
        "uspsInstructions2": "Hvis tilgjengelige planer fortsatt ikke dekker dine USPS-sporingsbehov, vennligst kontakt supportteamet v\xe5rt p\xe5 "
    },
    "pl": {
        "help": "Nie otrzymałem towaru",
        "quotaLimit": "Śledzenie USPS niedostępne. Osiągnięto limit.",
        "uspsLimitedTips": "Śledzenie USPS jest ograniczone z powodu zmian zasad. Ulepsz, aby uzyskać więcej żądań śledzenia.",
        "learnMore": "Dowiedz się więcej",
        "upgradePlan": "Uaktualnij teraz",
        "helpDesc": "Jesteśmy bardzo przepraszamy. 17TRACK to trzeciorzędowa globalna platforma agregująca informacje logistyczne, kt\xf3ra umożliwia łatwe sprawdzenie statusu logistycznego kilku paczek. W przypadku problem\xf3w z dostawą paczek skontaktuj się z firmą logistyczną lub handlowcem.",
        "helpTitle": "Szanowny użytkowniku",
        "website": "Strona internetowa",
        "noWebsite": "Brak dostępnych informacji o oficjalnej stronie internetowej. Zaleca się skontaktowanie się z sprzedawcą.",
        "contact": "Logistyczna info kontaktowa",
        "userAgree": "Zgadzam się na {0}",
        "userAgreeLink": "Warunki korzystania z usługi",
        "uspsTrackingInstructions": "Instrukcje śledzenia USPS",
        "uspsInstructions1": "Ze względu na zmiany polityki USPS, śledzenie USPS korzysta teraz z dedykowanego limitu. Płatni użytkownicy mogą dodawać numery śledzenia USPS do limitu swojego planu na cykl rozliczeniowy. Limit jest automatycznie resetowany.",
        "uspsInstructions2": "Jeśli dostępne plany nadal nie spełniają Twoich potrzeb związanych ze śledzeniem USPS, skontaktuj się z naszym zespołem pomocy technicznej pod adresem "
    },
    "pt-br": {
        "help": "N\xe3o recebi a mercadoria",
        "quotaLimit": "Rastreamento USPS indispon\xedvel. Limite atingido.",
        "uspsLimitedTips": "O rastreamento USPS est\xe1 limitado devido a mudan\xe7as de pol\xedtica. Atualize para obter mais solicita\xe7\xf5es de rastreamento.",
        "learnMore": "Saber mais",
        "upgradePlan": "Atualizar agora",
        "helpDesc": "Lamentamos muito. 17TRACK \xe9 uma plataforma terceirizada de agrega\xe7\xe3o de informa\xe7\xf5es log\xedsticas globais, que permite consultar convenientemente o status log\xedstico de m\xfaltiplos pacotes. Para problemas de entrega de pacotes, entre em contato com a empresa log\xedstica ou o comerciante.",
        "helpTitle": "Caro usu\xe1rio",
        "website": "Site oficial",
        "noWebsite": "Nenhuma informa\xe7\xe3o do site oficial dispon\xedvel. Recomenda-se entrar em contato com o vendedor.",
        "contact": "Info de contato de log\xedstica",
        "userAgree": "Aceitar os {0}",
        "userAgreeLink": "Termos de servi\xe7o",
        "uspsTrackingInstructions": "Instru\xe7\xf5es de rastreamento USPS",
        "uspsInstructions1": "Devido a altera\xe7\xf5es nas pol\xedticas dos USPS, o rastreamento USPS agora utiliza uma cota dedicada. Utilizadores pagantes podem adicionar n\xfameros de rastreamento USPS at\xe9 ao limite do seu plano por ciclo de faturamento. A cota \xe9 reposta automaticamente.",
        "uspsInstructions2": "Se os planos dispon\xedveis ainda n\xe3o atenderem \xe0s suas necessidades de rastreamento USPS, entre em contato com nossa equipe de suporte pelo e-mail "
    },
    "pt": {
        "help": "N\xe3o recebi a mercadoria",
        "quotaLimit": "Rastreamento USPS indispon\xedvel. Limite atingido.",
        "uspsLimitedTips": "O rastreamento USPS est\xe1 limitado devido a mudan\xe7as de pol\xedtica. Atualize para obter mais solicita\xe7\xf5es de rastreamento.",
        "learnMore": "Saber mais",
        "upgradePlan": "Atualizar agora",
        "helpDesc": "Lamentamos muito. 17TRACK \xe9 uma plataforma terceirizada de agrega\xe7\xe3o de informa\xe7\xf5es log\xedsticas globais, que permite consultar convenientemente o status log\xedstico de m\xfaltiplos pacotes. Para problemas de entrega de pacotes, entre em contato com a empresa log\xedstica ou o comerciante.",
        "helpTitle": "Caro usu\xe1rio",
        "website": "Site oficial",
        "noWebsite": "Nenhuma informa\xe7\xe3o do site oficial dispon\xedvel. Recomenda-se contactar o vendedor.",
        "contact": "Info de contato de log\xedstica",
        "userAgree": "Aceitar os {0}",
        "userAgreeLink": "Termos de servi\xe7o",
        "uspsTrackingInstructions": "Instru\xe7\xf5es de rastreamento USPS",
        "uspsInstructions1": "Devido a altera\xe7\xf5es nas pol\xedticas dos USPS, o rastreamento USPS agora utiliza uma cota dedicada. Utilizadores pagantes podem adicionar n\xfameros de rastreamento USPS at\xe9 ao limite do seu plano por ciclo de faturamento. A cota \xe9 reposta automaticamente.",
        "uspsInstructions2": "Se os planos dispon\xedveis ainda n\xe3o atenderem \xe0s suas necessidades de rastreamento USPS, entre em contato com nossa equipe de suporte pelo e-mail "
    },
    "ro": {
        "help": "Nu am primit produsul",
        "quotaLimit": "Urmărirea USPS nu este disponibilă. Limita a fost atinsă.",
        "uspsLimitedTips": "Urmărirea USPS este limitată din cauza schimbărilor de politică. Actualizează pentru mai multe solicitări de urmărire.",
        "learnMore": "Află mai multe",
        "upgradePlan": "Actualizează acum",
        "helpDesc": "Ne pare foarte rău. 17TRACK este o platformă terță de agregare a informațiilor logistice globale, care vă permite să verificați cu ușurință starea logisticii mai multor colete. Pentru probleme de livrare a coletelor, contactați compania logistică sau comerciantul.",
        "helpTitle": "Drag utilizatorule",
        "website": "Site-ul oficial",
        "noWebsite": "Nu există informații despre site-ul oficial disponibile. Se recomandă să contactați v\xe2nzătorul.",
        "contact": "Info de contact al logisticii",
        "userAgree": "Acceptați {0}",
        "userAgreeLink": "Termeni și condiții",
        "uspsTrackingInstructions": "Instrucțiuni de urmărire USPS",
        "uspsInstructions1": "Din cauza modificărilor politicilor USPS, urmărirea USPS utilizează acum o cotă dedicată. Utilizatorii plătitori pot adăuga numere de urmărire USPS p\xe2nă la limita planului lor pe ciclu de facturare. Cota este resetată automat.",
        "uspsInstructions2": "Dacă planurile disponibile \xeencă nu \xeeți satisfac nevoile de urmărire USPS, te rugăm să contactezi echipa noastră de asistență la "
    },
    "ru": {
        "help": "Я не получил(а) товар",
        "quotaLimit": "Отслеживание USPS недоступно. Достигнут лимит.",
        "uspsLimitedTips": "Отслеживание USPS ограничено из-за изменений политики. Обновите, чтобы получить больше запросов на отслеживание.",
        "learnMore": "Узнать больше",
        "upgradePlan": "Обновить сейчас",
        "helpDesc": "Мы искренне приносим свои извинения. 17TRACK — третейская глобальная платформа для агрегации логистической информации, которая позволяет удобно проверять логистический статус нескольких посылок. По вопросам доставки посылок свяжитесь с логистической компанией или продавцом.",
        "helpTitle": "Уважаемый пользователь",
        "website": "Официальный сайт",
        "noWebsite": "Информации об официальном сайте нет. Рекомендуется связаться с продавцом.",
        "contact": "Контактная информация логистики",
        "userAgree": "Согласен с {0}",
        "userAgreeLink": "Условия использования",
        "uspsTrackingInstructions": "Инструкции по отслеживанию USPS",
        "uspsInstructions1": "В связи с изменениями политики USPS отслеживание USPS теперь использует выделенную квоту. Платные пользователи могут добавлять номера отслеживания USPS в пределах лимита тарифа за каждый расчетный период. Квота автоматически сбрасывается.",
        "uspsInstructions2": "Если доступные тарифы по-прежнему не удовлетворяют ваши потребности в отслеживании USPS, обратитесь в нашу службу поддержки по адресу "
    },
    "sk": {
        "help": "Nedostal som tovar",
        "quotaLimit": "Sledovanie USPS nie je k dispoz\xedcii. Dosiahnut\xfd limit.",
        "uspsLimitedTips": "Sledovanie USPS je obmedzen\xe9 kv\xf4li zmen\xe1m politiky. Aktualizujte pre viac požiadaviek na sledovanie.",
        "learnMore": "Zistite viac",
        "upgradePlan": "Aktualizovať teraz",
        "helpDesc": "Veľmi sa omlouvame. 17TRACK je tretia strana glob\xe1lna platforma na agreg\xe1ciu logistick\xfdch inform\xe1ci\xed, ktor\xe1 v\xe1m umožňuje ľahko skontrolovať logistick\xfd stav viacer\xfdch bal\xedčkov. Pri probl\xe9moch s dodac\xedmi službami bal\xedčkov kontaktujte logistick\xfa spoločnosť alebo obchodn\xedka.",
        "helpTitle": "Ctitel\xfd už\xedvateľ",
        "website": "Ofici\xe1lna webstr\xe1nka",
        "noWebsite": "Žiadne inform\xe1cie o ofici\xe1lnej webovej str\xe1nke nie s\xfa k dispoz\xedcii. Odpor\xfača sa kontaktovať predajcu.",
        "contact": "Logistick\xe1 kontaktn\xe1 info",
        "userAgree": "S\xfahlas\xedm s {0}",
        "userAgreeLink": "Podmienky služby",
        "uspsTrackingInstructions": "Pokyny na sledovanie USPS",
        "uspsInstructions1": "Kv\xf4li zmen\xe1m politiky USPS, sledovanie USPS teraz použ\xedva vyhraden\xfa kv\xf3tu. Platiaci použ\xedvatelia m\xf4žu pridať sledovacie č\xedsla USPS až do limitu svojho pl\xe1nu za fakturačn\xfd cyklus. Kv\xf3ta sa automaticky resetuje.",
        "uspsInstructions2": "Ak dostupn\xe9 pl\xe1ny st\xe1le nespĺňaj\xfa vaše potreby sledovania USPS, kontaktujte n\xe1š t\xedm podpory na adrese "
    },
    "sl": {
        "help": "Nisem prejel(a) blago",
        "quotaLimit": "Sledenje USPS ni na voljo. Dosežena je bila omejitev.",
        "uspsLimitedTips": "Sledenje USPS je omejeno zaradi sprememb pravilnika. Nadgradite za več zahtev za sledenje.",
        "learnMore": "Več informacij",
        "upgradePlan": "Nadgradi zdaj",
        "helpDesc": "Zelo se opravičujemo. 17TRACK je tretja stran globalna platforma za agregacijo logističnih informacij, ki omogoča enostavno preverjanje logističnega stanja več paketov. Pri problemih z dostavo paketov kontaktirajte logistično podjetje ali trgovca.",
        "helpTitle": "Spoštovani uporabnik",
        "website": "Zasebna spletna stran",
        "noWebsite": "Ni na voljo informacij o uradni spletni strani. Priporočamo, da se povežete z prodajalcem.",
        "contact": "Logistična kontaktna info",
        "userAgree": "Strinjam se z {0}",
        "userAgreeLink": "Pogoji uporabe",
        "uspsTrackingInstructions": "Navodila za sledenje USPS",
        "uspsInstructions1": "Zaradi sprememb pravilnikov USPS, sledenje USPS zdaj uporablja namensko kvoto. Plačljivi uporabniki lahko dodajajo številke za sledenje USPS do meje svojega načrta na obračunski cikel. Kvota se samodejno ponastavi.",
        "uspsInstructions2": "Če razpoložljivi paketi še vedno ne izpolnjujejo vaših potreb po sledenju USPS, se obrnite na našo ekipo za podporo na "
    },
    "sq": {
        "help": "Nuk kam marr\xeb mallin",
        "quotaLimit": "Gjurmimi i USPS nuk \xebsht\xeb i disponuesh\xebm. Limiti \xebsht\xeb arritur.",
        "uspsLimitedTips": "Gjurmimi i USPS \xebsht\xeb i kufizuar p\xebr shkak t\xeb ndryshimeve t\xeb politik\xebs. P\xebrmir\xebso p\xebr m\xeb shum\xeb k\xebrkesa gjurmimi.",
        "learnMore": "M\xebso m\xeb shum\xeb",
        "upgradePlan": "P\xebrmir\xebso tani",
        "helpDesc": "Ne jemi shum\xeb t\xeb ndjesh\xebm. 17TRACK \xebsht\xeb nj\xeb platform\xeb e tret\xeb p\xebr agregimin e informacioneve logjistike globale, e cila ju lejon t\xeb kontrolloni me leht\xebsi statusin logjistik t\xeb shum\xeb paketave. P\xebr probleme me dor\xebzimin e paketave, kontaktoni kompani logjistike ose tregtarin.",
        "helpTitle": "Z\xebvend\xebsues i nderuar",
        "website": "Faqja zyrtare",
        "noWebsite": "Nuk ka informacione p\xebr faqen zyrtare t\xeb disponueshme. Rekomandohet t\xeb kontaktohet me shit\xebsi.",
        "contact": "Info kontakti i logjistik\xebs",
        "userAgree": "Pranoj {0}",
        "userAgreeLink": "Kushtet e sh\xebrbimit",
        "uspsTrackingInstructions": "Udh\xebzime p\xebr gjurmimin USPS",
        "uspsInstructions1": "P\xebr shkak t\xeb ndryshimeve t\xeb politikave t\xeb USPS, gjurmimi i USPS tani p\xebrdor nj\xeb kuot\xeb t\xeb dedikuar. P\xebrdoruesit me pages\xeb mund t\xeb shtojn\xeb numra gjurmimi t\xeb USPS deri n\xeb kufirin e planit t\xeb tyre p\xebr cik\xebl faturimi. Kuota rivendoset automatikisht.",
        "uspsInstructions2": "N\xebse planet e disponueshme ende nuk i plot\xebsojn\xeb nevojat tuaja p\xebr gjurmimin e USPS, ju lutemi kontaktoni ekipin ton\xeb mb\xebshtet\xebs n\xeb "
    },
    "sr": {
        "help": "Нисам добио(ла) робу",
        "quotaLimit": "Праћење USPS-а није доступно. Достигнуто је ограничење.",
        "uspsLimitedTips": "Praćenje USPS je ograničeno zbog promena politike. Nadogradite za više zahteva za praćenje.",
        "learnMore": "Сазнајте више",
        "upgradePlan": "Nadogradi sada",
        "helpDesc": "Много се извињајемо. 17TRACK је трећа страна глобална платформа за агрегацију логистичких информација, која омогућава лако проверања логистичког статуса неколико пакета. За проблеме са испоруком пакета, контактирајте логистичку компанију или трговца.",
        "helpTitle": "Poštovani korisniku",
        "website": "Официјални сајт",
        "noWebsite": "Нема информација о званичном сајту. Предлажемо да контактирате Продавца.",
        "contact": "Логистичка контактна информација",
        "userAgree": "Прихватам {0}",
        "userAgreeLink": "Услови коришћења",
        "uspsTrackingInstructions": "Uputstva za praćenje USPS",
        "uspsInstructions1": "Zbog promene politike USPS-a, praćenje USPS-a sada koristi namensku kvotu. Korisnici koji plaćaju mogu dodati brojeve za praćenje USPS-a do granice svog plana po ciklusu naplate. Kvota se automatski resetuje.",
        "uspsInstructions2": "Ukoliko dostupni planovi i dalje ne zadovoljavaju vaše potrebe za praćenjem USPS-a, kontaktirajte naš tim za podršku na "
    },
    "sv": {
        "help": "Jag har inte f\xe5tt varorna",
        "quotaLimit": "USPS-sp\xe5rning \xe4r inte tillg\xe4nglig. Gr\xe4nsen \xe4r n\xe5dd.",
        "uspsLimitedTips": "USPS-sp\xe5rning \xe4r begr\xe4nsad p\xe5 grund av policy\xe4ndringar. Uppgradera f\xf6r fler sp\xe5rningsf\xf6rfr\xe5gningar.",
        "learnMore": "L\xe4s mer",
        "upgradePlan": "Uppgradera nu",
        "helpDesc": "Vi \xe4r ytterst ledsna. 17TRACK \xe4r en tredjepartsplattform f\xf6r global aggregering av logistisk information, som g\xf6r att du enkelt kan kontrollera logistiken f\xf6r flera paket. F\xf6r leveransproblem med paket, kontakta logistiksf\xf6retaget eller handlaren.",
        "helpTitle": "K\xe4ra anv\xe4ndare",
        "website": "Officiell webbplats",
        "noWebsite": "Ingen information om den officiella webbplatsen tillg\xe4nglig. Rekommenderas att kontakta s\xe4ljaren.",
        "contact": "Logistik kontaktinfo",
        "userAgree": "Godk\xe4nn {0}",
        "userAgreeLink": "Anv\xe4ndarvillkor",
        "uspsTrackingInstructions": "USPS-sp\xe5rningsinstruktioner",
        "uspsInstructions1": "P\xe5 grund av policy\xe4ndringar fr\xe5n USPS anv\xe4nder USPS-sp\xe5rning nu en dedikerad kvot. Betalande anv\xe4ndare kan l\xe4gga till USPS-sp\xe5rningsnummer upp till sitt plangr\xe4ns per faktureringscykel. Kvoten \xe5terst\xe4lls automatiskt.",
        "uspsInstructions2": "Om de tillg\xe4ngliga planerna fortfarande inte uppfyller dina USPS-sp\xe5rningsbehov, v\xe4nligen kontakta v\xe5rt supportteam p\xe5 "
    },
    "th": {
        "help": "ฉันไม่ได้รับสินค้า",
        "quotaLimit": "ไม่สามารถติดตามพัสดุของ USPS ได้ เนื่องจากถึงขีดจำกัดแล้ว",
        "uspsLimitedTips": "การติดตาม USPS ถูกจำกัดเนื่องจากการเปลี่ยนนโยบาย อัปเกรดเพื่อรับคำขอติดตามเพิ่มเติม",
        "learnMore": "เรียนรู้เพิ่มเติม",
        "upgradePlan": "อัปเกรดตอนนี้",
        "helpDesc": "ขอโทษมากค่ะ/ครับ. 17TRACK เป็นแพลตฟอร์มรวบรวมข้อมูลโลจิสติกส์โลกwide จากบุคคลที่สาม ที่ช่วยให้คุณตรวจสอบสถานะโลจิสติกส์ของพัสดุหลายรายการได้สะดวก สำหรับปัญหาเกี่ยวกับการส่งมอบพัสดุ ขอแนะนำให้ติดต่อ บริษัท โลจิสติกส์หรือผู้ค้า",
        "helpTitle": "คุณผู้ใช้ที่เคารพ",
        "website": "เว็บไซต์ الرسمي",
        "noWebsite": "ไม่มีข้อมูลเว็บไซต์ทางการพร้อมใช้งาน ขอแนะนำให้ติดต่อผู้ขาย",
        "contact": "ข้อมูลติดต่อ บริษัท логисติก",
        "userAgree": "ยอมรับ{0}",
        "userAgreeLink": "ข้อกำหนดการให้บริการ",
        "uspsTrackingInstructions": "คำแนะนำการติดตาม USPS",
        "uspsInstructions1": "เนื่องจากการเปลี่ยนแปลงนโยบายของ USPS การติดตามพัสดุ USPS ขณะนี้ใช้โควต้าเฉพาะ ผู้ใช้ที่ชำระเงินสามารถเพิ่มหมายเลขติดตาม USPS ได้จนถึงขีดจำกัดแผนต่อรอบการเรียกเก็บเงิน โควต้าจะถูกรีเซ็ตโดยอัตโนมัติ",
        "uspsInstructions2": "หากแผนที่มีอยู่ยังไม่ตรงกับความต้องการติดตาม USPS ของคุณ โปรดติดต่อทีมสนับสนุนของเราที่ "
    },
    "tr": {
        "help": "\xdcr\xfcn\xfc almadım",
        "quotaLimit": "USPS takip bilgileri mevcut değil. Limit aşıldı.",
        "uspsLimitedTips": "USPS takibi politika değişiklikleri nedeniyle sınırlıdır. Daha fazla takip isteği i\xe7in y\xfckseltin.",
        "learnMore": "Daha fazla bilgi edin",
        "upgradePlan": "Şimdi y\xfckselt",
        "helpDesc": "\xc7ok \xfczg\xfcn\xfcz. 17TRACK, global bir \xfc\xe7\xfcnc\xfc parti lojistik bilgi toplama platformudur ve size birden fazla paketin lojistik durumunu kolayca kontrol etme imkanı tanır. Paket teslimat sorunları i\xe7in lojistik şirketi veya satıcı ile iletişime ge\xe7iniz.",
        "helpTitle": "Sayın kullanıcı",
        "website": "Resmi web sitesi",
        "noWebsite": "Resmi web sitesi bilgisi yok. Satıcı ile iletişime ge\xe7meniz \xf6nerilir.",
        "contact": "Lojistik iletişim info",
        "userAgree": "{0}'yi kabul et",
        "userAgreeLink": "Hizmet Şartları",
        "uspsTrackingInstructions": "USPS takip talimatları",
        "uspsInstructions1": "USPS politika değişiklikleri nedeniyle USPS takibi artık \xf6zel bir kota kullanmaktadır. \xdccretli kullanıcılar, fatura d\xf6ng\xfcs\xfc başına plan limitleri dahilinde USPS takip numarası ekleyebilir. Kota otomatik olarak sıfırlanır.",
        "uspsInstructions2": "Mevcut planlar USPS takip ihtiya\xe7larınızı h\xe2l\xe2 karşılamıyorsa, l\xfctfen destek ekibimizle  adresinden iletişime ge\xe7in."
    },
    "uk": {
        "help": "Я не отримав(ла) товар",
        "quotaLimit": "Відстеження USPS недоступне. Досягнуто ліміту.",
        "uspsLimitedTips": "Відстеження USPS обмежене через зміни політики. Оновіть, щоб отримати більше запитів на відстеження.",
        "learnMore": "Дізнатися більше",
        "upgradePlan": "Оновити зараз",
        "helpDesc": "Ми дуже вибачаємося. 17TRACK — третій-сторонна глобальна платформа для агрегації логістичної інформації, яка дозволяє зручно перевірити логістичний статус кількох посилок. За питаннями доставки посилок зв'яжіться з логістичною компанією або продавцем.",
        "helpTitle": "Dear user",
        "website": "Офіційний сайт",
        "noWebsite": "Інформації про офіційний сайт немає. Рекомендується зв’язатися з продавцем.",
        "contact": "Контактна інформація логістики",
        "userAgree": "Погоджуюся з {0}",
        "userAgreeLink": "Умови використання",
        "uspsTrackingInstructions": "Інструкції з відстеження USPS",
        "uspsInstructions1": "Через зміни політики USPS, відстеження USPS тепер використовує виділену квоту. Платні користувачі можуть додавати номери відстеження USPS відповідно до ліміту свого тарифу за кожний платіжний цикл. Квота автоматично скидається.",
        "uspsInstructions2": "Якщо наявні тарифи все ще не задовольняють ваші потреби у відстеженні USPS, зв’яжіться з нашою службою підтримки за адресою "
    },
    "vi": {
        "help": "T\xf4i chưa nhận được h\xe0ng h\xf3a",
        "quotaLimit": "Dịch vụ theo d\xf5i bưu kiện USPS kh\xf4ng khả dụng. Đ\xe3 đạt giới hạn.",
        "uspsLimitedTips": "Theo d\xf5i USPS bị giới hạn do thay đổi ch\xednh s\xe1ch. N\xe2ng cấp để c\xf3 th\xeam y\xeau cầu theo d\xf5i.",
        "learnMore": "T\xecm hiểu th\xeam",
        "upgradePlan": "N\xe2ng cấp ngay",
        "helpDesc": "Rất tiếc. 17TRACK l\xe0 nền tảng tổng hợp th\xf4ng tin logistics to\xe0n cầu của b\xean thứ ba, cho ph\xe9p bạn tiện lợi kiểm tra t\xecnh trạng logistics của nhiều g\xf3i h\xe0ng. Với vấn đề giao h\xe0ng g\xf3i h\xe0ng, vui l\xf2ng li\xean hệ với c\xf4ng ty logistics hoặc doanh nghiệp.",
        "helpTitle": "K\xednh gửi người d\xf9ng",
        "website": "Trang web ch\xednh thức",
        "noWebsite": "Kh\xf4ng c\xf3 th\xf4ng tin trang web ch\xednh thức khả dụng. Khuyến nghị li\xean hệ với người b\xe1n.",
        "contact": "Info li\xean hệ logistics",
        "userAgree": "Đồng \xfd với {0}",
        "userAgreeLink": "Điều khoản dịch vụ",
        "uspsTrackingInstructions": "Hướng dẫn theo d\xf5i USPS",
        "uspsInstructions1": "Do những thay đổi ch\xednh s\xe1ch của USPS, dịch vụ theo d\xf5i USPS hiện sử dụng hạn ngạch d\xe0nh ri\xeang. Người d\xf9ng trả ph\xed c\xf3 thể th\xeam m\xe3 theo d\xf5i USPS l\xean đến giới hạn g\xf3i dịch vụ mỗi chu kỳ thanh to\xe1n. Hạn ngạch được đặt lại tự động.",
        "uspsInstructions2": "Nếu c\xe1c g\xf3i hiện c\xf3 vẫn kh\xf4ng đ\xe1p ứng nhu cầu theo d\xf5i USPS của bạn, vui l\xf2ng li\xean hệ với nh\xf3m hỗ trợ của ch\xfang t\xf4i qua địa chỉ "
    },
    "zh-cn": {
        "help": "我没收到货",
        "quotaLimit": "USPS追踪暂不可用，次数已达上限",
        "uspsLimitedTips": "由于政策调整，USPS 查询受到限制。升级以获取更多查询权限。",
        "learnMore": "了解更多",
        "upgradePlan": "立即升级",
        "helpDesc": "万分抱歉，17TRACK 是全球物流信息第三方聚合平台，可让您便捷查询多个包裹的物流状态。包裹的配送问题请联系物流公司或商家。",
        "helpTitle": "尊敬的用户",
        "website": "官网",
        "noWebsite": "暂无官网信息，建议联系卖家",
        "contact": "物流公司联系方式",
        "userAgree": "同意17TRACK{0}",
        "userAgreeLink": "服务条款",
        "uspsTrackingInstructions": "USPS 查询说明",
        "uspsInstructions1": "受 USPS 政策调整影响，USPS 查询现采用专用额度制。付费用户每个结算周期内可按套餐上限添加 USPS 查询号，额度自动重置。",
        "uspsInstructions2": "如果现有套餐仍无法满足您的 USPS 查询需求，请联系我们的客服团队："
    },
    "zh-hk": {
        "help": "我沒收到貨",
        "quotaLimit": "USPS追蹤暫不可用，次數已達上限",
        "uspsLimitedTips": "由於政策調整，USPS 查詢受到限制。升級以獲取更多查詢權限。",
        "learnMore": "了解更多",
        "upgradePlan": "立即升級",
        "helpDesc": "萬分抱歉，17TRACK 是全球物流資訊第三方聚合平台，可讓您便捷查詢多個包裹的物流狀態。包裹的配送問題請聯繫物流公司或商家。",
        "helpTitle": "尊敬的用戶",
        "website": "官網",
        "noWebsite": "暫無官網資訊，建議聯繫賣家",
        "contact": "物流公司聯繫方式",
        "userAgree": "同意17TRACK{0}",
        "userAgreeLink": "服務條款",
        "uspsTrackingInstructions": "USPS 查詢說明",
        "uspsInstructions1": "受 USPS 政策調整影響，USPS 查詢現採用專用額度制。付費用戶每個結算週期內可按套餐上限添加 USPS 查詢號，額度自動重置。",
        "uspsInstructions2": "如果現有套餐仍無法滿足您的 USPS 查詢需求，請聯繫我們的客服團隊："
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (text);


/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interopRequireDefault = (__webpack_require__(7022)/* ["default"] */ .Z);
var _jsxRuntime = __webpack_require__(4637);
var _reactHelmet = __webpack_require__(3893);
var _head = /*#__PURE__*/ _interopRequireDefault(__webpack_require__(1078));
var CommonMeta = function(props) {
    var $t = props.$t;
    var ResUnim = $t("ResUnim.global");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactHelmet.Helmet, {
                meta: [
                    {
                        charSet: "utf-8"
                    },
                    {
                        httpEquiv: "X-UA-Compatible",
                        content: "IE=edge,chrome=1"
                    },
                    {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no"
                    },
                    {
                        name: "description",
                        content: ResUnim.__seoDesc
                    },
                    {
                        name: "keywords",
                        content: ResUnim.__seoKeyword
                    },
                    {
                        itemprop: "name",
                        content: "".concat(ResUnim.__seoTitle, " | 17TRACK")
                    },
                    {
                        itemprop: "description",
                        content: ResUnim.__seoDesc
                    },
                    {
                        itemprop: "url",
                        content: "https://www.17track.net"
                    },
                    {
                        itemprop: "image",
                        content: "https://res.17track.net/global-v2/imgs/oauth_image/share.png"
                    },
                    {
                        property: "og:type",
                        content: "website"
                    },
                    {
                        property: "og:url",
                        content: "https://m.17track.net"
                    },
                    {
                        property: "og:title",
                        content: ResUnim.__seoTitle
                    },
                    {
                        property: "og:description",
                        content: ResUnim.__seoDesc
                    },
                    {
                        property: "og:image",
                        content: "https://res.17track.net/global-v2/imgs/oauth_image/share.png"
                    },
                    {
                        name: "msapplication-TileColor",
                        content: "#003A9B"
                    },
                    {
                        name: "theme-color",
                        content: "#003A9B"
                    },
                    {
                        name: "author",
                        content: "admin@17track.net"
                    },
                    {
                        name: "msapplication-tap-highlight",
                        content: "no"
                    },
                    {
                        name: "apple-itunes-app",
                        content: "app-id=1004956012"
                    },
                    {
                        name: "google-play-app",
                        content: "app-id=yqtrack.app"
                    },
                    {
                        name: "msApplication-ID",
                        content: "17TRACK.17TRACK"
                    },
                    {
                        name: "msApplication-PackageFamilyName",
                        content: "17TRACK.17TRACK_vs3bzqqr3bhre"
                    },
                    {
                        name: "qc:admins",
                        content: "1027553633526174213366547"
                    }
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_head.default, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("title", {
                    children: [
                        ResUnim.__seoTitle,
                        " | 17TRACK"
                    ]
                })
            })
        ]
    });
};
var _default = CommonMeta;
module.exports = CommonMeta;


/***/ }),

/***/ 2517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_useXState; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(2006);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9496);
// EXTERNAL MODULE: ./node_modules/.pnpm/immutability-helper@3.1.1/node_modules/immutability-helper/index.js
var immutability_helper = __webpack_require__(5899);
var immutability_helper_default = /*#__PURE__*/__webpack_require__.n(immutability_helper);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(6091);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(1962);
;// CONCATENATED MODULE: ./src/utils/tool.ts
// interface tool{
// deepClone: Function 
// }
// let tool:tool = {
//   deepClone:function():void{}
// }


var Tool = /*#__PURE__*/ function() {
    "use strict";
    function Tool() {
        (0,_class_call_check/* default */.Z)(this, Tool);
    }
    var _proto = Tool.prototype;
    _proto.deepClone = function deepClone(obj) {
        var o;
        // 如果  他是对象object的话  , 因为null,object,array  也是'object'
        if (typeof obj === "object") {
            // 如果  他是空的话
            if (obj === null) {
                o = null;
            } else {
                // 如果  他是数组arr的话
                if ((0,_instanceof/* default */.Z)(obj, Array)) {
                    o = [];
                    for(var i = 0, len = obj.length; i < len; i++){
                        o.push(this.deepClone(obj[i]));
                    }
                } else {
                    o = {};
                    for(var j in obj){
                        o[j] = this.deepClone(obj[j]);
                    }
                }
            }
        } else {
            o = obj;
        }
        return o;
    };
    return Tool;
}();
// 定义一个深拷贝函数  接收目标target参数
// tool.deepClone = function (obj:any) {
//   let o
//   // 如果  他是对象object的话  , 因为null,object,array  也是'object'
//   if (typeof obj === "object") {
//     // 如果  他是空的话
//     if (obj === null) {
//       o = null
//     } else {
//       // 如果  他是数组arr的话
//       if (obj instanceof Array) {
//         o = []
//         for (let i = 0, len = obj.length; i < len; i++) {
//           o.push(tool.deepClone(obj[i]))
//         }
//       }
//       // 如果  他是对象object的话
//       else {
//         o = {}
//         for (let j in obj) {
//           o[j] = tool.deepClone(obj[j])
//         }
//       }
//     }
//   } else {
//     o = obj
//   }
//   return o
// }
/* harmony default export */ var tool = (new Tool());

;// CONCATENATED MODULE: ./src/utils/useXState.ts
/**
 *@Description: 针对useState多个创建封装的方法
*/ 



//获取immutability-helper更新表达式
function getUpdateSpec(key, value) {
    var $spec = {};
    if (typeof key == "string") {
        var set = {
            $set: value
        };
        var $spec_cur = {};
        var arr = key.split(".");
        if (arr.length == 1) {
            //单个直接set
            $spec[key] = set;
        } else {
            for(var index = 0; index < arr.length; index++){
                var i = arr[index];
                if (index == 0) {
                    $spec[i] = {};
                } else {
                    $spec_cur = $spec[arr[index - 1]];
                    if (index == arr.length - 1) {
                        $spec_cur[i] = set;
                    } else {
                        $spec_cur[i] = {};
                    }
                }
            }
        }
    } else {
        return key;
    }
    return $spec;
}
// 自定义useState
function useXState(defaultState) {
    var setState = function setState() {
        for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
            arr[_key] = arguments[_key];
        }
        if (!arr || arr.length < 1) {
            return;
        }
        var payload = arr[0];
        var value = undefined;
        var callback = undefined;
        if (typeof payload == "string") {
            value = arr[1];
            callback = arr[2];
            dispatch({
                type: "string",
                key: payload,
                value: value,
                callback: callback
            });
        } else if (typeof payload == "function") {
            value = payload;
            callback = arr[1];
            dispatch({
                type: "function",
                key: payload,
                value: value,
                callback: callback
            });
        } else {
            value = payload;
            callback = arr[1];
            dispatch({
                type: "object",
                key: payload,
                value: value,
                callback: callback
            });
        }
    };
    var setStateBySpec = //immutability-helper表达式方式更新
    function setStateBySpec() {
        for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
            arr[_key] = arguments[_key];
        }
        if (!arr || arr.length < 1) {
            return;
        }
        var payload = arr[0];
        var value = undefined;
        var callback = undefined;
        value = payload;
        callback = arr[1];
        dispatch({
            type: "spec",
            key: payload,
            value: value,
            callback: callback
        });
    };
    var reducer = (0,react.useCallback)(function(state, action) {
        //console.log(action);
        var result = {};
        if (action.type == "string") {
            var $spec = getUpdateSpec(action.key, action.value);
            result = immutability_helper_default()(state, $spec);
        } else if (action.type == "spec") {
            var $spec1 = action.value;
            result = immutability_helper_default()(state, $spec1);
        } else if (action.type == "function") {
            var fn = action.key;
            result = tool.deepClone(state);
            fn(result);
        } else {
            result = tool.deepClone(state);
            result = (0,_object_spread/* default */.Z)({}, state, action.value);
        }
        if (action.callback) action.callback(result);
        return result;
    }, []);
    var ref = (0,react.useReducer)(reducer, defaultState), state = ref[0], dispatch = ref[1];
    return [
        state,
        setState,
        setStateBySpec
    ];
}
// function useCallbackState(od) {
//   const cbRef = useRef();
//   const [data, setData] = useState(od);
//   useEffect(() => {
//     cbRef.current && cbRef.current(data);
//   }, [data]);
//   return [
//     data,
//     function (key, value, callback) {
//       cbRef.current = callback;
//       const $spec = getUpdateSpec(key, value);
//       setData(update(data, $spec));
//     },
//     function (d, callback) {
//       cbRef.current = callback;
//       setData(update(data, d));
//     },
//     function (d, callback) {
//       cbRef.current = callback;
//       setData(d);
//     },
//   ];
// }
/* harmony default export */ var utils_useXState = (useXState);


/***/ })

}]);